import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton, Box, Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import PregnancyVeousRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useState } from "react";
import ByzDeleteConfirmDialog from "src/components/core-components/mui/ByzDeleteConfirmDialog";
import PregnancyVenous from "../create";
import { useTranslate } from "src/locales/use-locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

function PregnancyVeousList() {
  const { t } = useTranslate();
  const [openDelete, setOpenDelete] = useState(false);
  const [patientId, setpatientId] = useState("");

  const handleDeleteClick = (patientId: string) => {
    setpatientId(patientId);
    setOpenDelete(true);
  };

  const columns: GridColDef[] = [
    {
      field: "update",
      headerName: "Güncelle",
      width: 150,
      renderCell(params) {
        return (
          <Link to={`edit/${params.row.id}`}>
            <EditIcon color="info" />
          </Link>
        );
      },
    },
    { field: "date", headerName: "Tarih", flex: 1 },
    { field: "field1", headerName: "Alan 1", flex: 1 },
    { field: "field2", headerName: "Alan 2", flex: 1 },
    { field: "field3", headerName: "Alan 3", flex: 1 },
    { field: "field4", headerName: "Alan 4", flex: 1 },
    { field: "field5", headerName: "Alan 5", flex: 1 },
    {
      field: "delete",
      headerName: "Sil",
      flex: 1,
      renderCell: (params) => (
        <IconButton onClick={() => handleDeleteClick(params.row.id)}>
          <DeleteIcon color="error" />
        </IconButton>
      ),
    },
  ];

  return (
    <BaseMedCardList
      title={t('pregnancy-venous.title')}
      CreateComponent={PregnancyVenous}
      columns={columns}
      rows={PregnancyVeousRows}
    >
      <ByzMuiTypography
        sx={{
          fontSize: 13,
          fontWeight: 400,
          whiteSpace: "pre-line",
          wordWrap: "break-word",
          margin: 0,
        }}
      >
        <Grid container spacing={2} sx={{ width: "100%" }}>
          {/* Açıklama Panelleri */}
          <Grid item xs={12} md={3} sx={{ padding: "10px", color: "red", borderRight: { md: "1px solid black", xs: "none" } }}>
            <b>Antenatal Dönem Toplam Puan :</b><br />
            {`Antenatal dönemde toplam puan 
1) >=4 ise 1.trimesterden itibaren tromboproflaksi önerilir. 
2) Toplam puan 3 ise 28. haftadan itibaren önerilir. 
3) Hastaneye yatış durumunda önerilir.`}
          </Grid>

          <Grid item xs={12} md={3} sx={{ padding: "10px", color: "red", borderRight: { md: "1px solid black", xs: "none" } }}>
            <b>Postnatal Dönem Toplam Puan :</b><br />
            {`1) Toplam puan >=2 ise en az 10 gün önerilir. 
2) >=3 gün yatış veya tekrar yatışta önerilir. 
3) Kanama riski olanlar hematoloji ile tartışılmalıdır.`}
          </Grid>

          <Grid item xs={12} md={3} sx={{ padding: "10px", color: "red", borderRight: { md: "1px solid black", xs: "none" } }}>
            {`Doğum öncesi sezaryen ihtimali olan gebelerde DMAH/AFH dozu doğumdan bir gün önce alınmalı; sabah dozu alınmadan operasyon yapılmalıdır.

Antenatal ve Postnatal DMHA Profilaktik Dozu`}
          </Grid>

          {/* Tablolu Doz Bilgisi */}
          <Grid item xs={12} md={3} sx={{ padding: "10px" }}>
            <Box sx={{ overflowX: "auto" }}>
              <Box sx={{ minWidth: 600 }}>
                <Grid container spacing={2}>
                  {/* Başlık */}
                  <Grid container item spacing={2} sx={{ fontWeight: "bold" }}>
                    <Grid item xs={3}>Ağırlık</Grid>
                    <Grid item xs={3}>Enoxaparin</Grid>
                    <Grid item xs={3}>Dalteparin</Grid>
                    <Grid item xs={3}>Tinzaparin</Grid>
                  </Grid>

                  {/* İçerik */}
                  {[
                    ["<50", "20", "2500", "2500"],
                    ["50-90", "40", "5000", "4500"],
                    ["91-130", "60", "7500", "7500"],
                    ["130-170", "80", "10000", "9000"],
                    [">170", "0.6 mg/kg/gün", "75U/kg/gün", "75U/kg/gün"]
                  ].map(([weight, enox, dalt, tinz], index) => (
                    <Grid container item spacing={2} key={index}>
                      <Grid item xs={3}>{weight}</Grid>
                      <Grid item xs={3}>{enox}</Grid>
                      <Grid item xs={3}>{dalt}</Grid>
                      <Grid item xs={3}>{tinz}</Grid>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Silme Onay Dialogu */}
        <ByzDeleteConfirmDialog
          open={openDelete}
          onClose={() => setOpenDelete(false)}
          patientId={patientId}
        />

      </ByzMuiTypography>

      {/* Duplicate delete dialog - keeping for backward compatibility */}
      <ByzDeleteConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        patientId={patientId}
      />
    </BaseMedCardList>
  );
}

export default PregnancyVeousList;
